import React from 'react';
import { Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData, RedirectToLoginBiEvent } from '@wix/da-bi/pkg/events';

import s from './CommentForAnonymous.scss';

const CommentForAnonymous: React.FC = () => {
  return (
    <div className={s.root}>
      <Trans i18nKey="commentbox.anonymous.message" parent="span">
        <BiLink
          href={Url.joinLink()}
          className={s.link}
          biData={BiData<RedirectToLoginBiEvent>({
            evid: 240,
            referral_info: ReferralType.COMMENT,
          })}
        >
          Join the community
        </BiLink>
        {' to add your comment. Already a deviant? '}
        <a href={Url.loginLink()} className={s.link}>
          Sign In
        </a>
      </Trans>
    </div>
  );
};

CommentForAnonymous.displayName = 'CommentForAnonymous';
export default CommentForAnonymous;
